import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Messagecentral} from '../../shared/api/messagecentrals/api.models';
import {ModalService} from '../../shared/modal.service';
import {MessagecentralModal} from './components/messagecentral.modal';
import {Utils} from '../../shared/utils.service';
import {Api} from '../../shared/api.service';

@Component({
    selector: 'settings-messagecentrals',
    template: require('./messagecentrals.component.html')
})

export class MessagecentralsComponent implements OnInit {

    protected messagecentrals: Messagecentral[] = [];

    constructor(private route: ActivatedRoute, private modal: ModalService, private utils: Utils, private api: Api) {}

    ngOnInit() {
        this.messagecentrals = this.route.snapshot.data['messagecentrals'] as Messagecentral[];
    }

    new() {
        let messagecentral = new Messagecentral();

        delete messagecentral.preferences.defaultMessageCollection.messages;
        delete messagecentral.preferences.defaultMessageCollection.state;


        this.createModal(messagecentral).then(
            (messagecentral: Messagecentral) => {
                this.messagecentrals.push(messagecentral);
                this.utils.sortList(this.messagecentrals, 'name');

            },
            () => {}
        )
    }

    edit(entity: Messagecentral) {
        let editable = JSON.parse(JSON.stringify(entity));

        this.createModal(editable).then(
            (result: Messagecentral) => {
                Object.assign(entity, result);
                this.utils.sortList(this.messagecentrals, 'name');
            },
            () => { }
        );
    }

    clone(entity: Messagecentral) {
        let editable = JSON.parse(JSON.stringify(entity));
        editable.id  = null;

        this.createModal(editable).then(
            (result: Messagecentral) => {
                this.messagecentrals.push(result);
                this.utils.sortList(this.messagecentrals, 'name');
            },
            () => {}
        );
    }

    delete(entity: Messagecentral) {
        this.modal.confirm('Remove messagecentral', 'Are you sure you want to remove ' + entity.name + '?').then(
            () => {
                this.api.messagecentrals().remove(entity.id).subscribe(
                    () => {
                        this.messagecentrals.splice(this.messagecentrals.indexOf(entity), 1);
                    },
                    () => {}
                );
            }
        );
    }

    private createModal(entity: Messagecentral): Promise<Messagecentral> {
        let modal = this.modal.custom(MessagecentralModal);

        modal.componentInstance.messagecentral = entity;
        modal.componentInstance.languages      = this.route.snapshot.data['languages'];

        return modal.result;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/messagecentrals/messagecentrals.component.ts